import { useContext } from 'react'
import styled from 'styled-components'
import { t } from 'ttag'

import { Text } from '@h2/components/typography/text'
import { UserSettingsIcon } from '@h2/components/icons/userSettings'
import { GroupsIcon } from '@h2/components/icons/groups'
import { LessonPlanIcon } from '@h2/components/icons/lessonPlan'
import { CoverLetterIcon } from '@h2/components/icons/coverLetter'
import { NetworkIcon } from '@h2/components/icons/network'
import { PB70T } from '@h2/components/colors'
import { Globals } from '@h2/globals'

import { subNavList, navLink } from '../navigation/mixins'
import { Link as LinkComponent } from '../../link'

const Nav = styled.nav`
  position: relative;
`
const Link = styled(LinkComponent)`
  ${navLink};
  flex-direction: row;
  background-color: white;

  > span[role='img'] {
    margin-right: 8px;
  }
`
const List = styled.ul`
  ${subNavList};
  left: auto;
  right: 0;
  flex-direction: column;
  width: auto;
  box-shadow: 0 3px 6px ${PB70T};

  > li {
    width: auto;
    border: none;
  }
  z-index: 2;
`
const Menu = () => {
  const {
    versionThreeLocalOpportunities,
    hasLocalOpportunities,
    isSubscriber,
    user: { isRoot }
  } = useContext(Globals)

  return (
    <Nav>
      <List>
        <li>
          <Link href="/management/users">
            <UserSettingsIcon />
            <Text as="span" size="medium">
              {t`Users`}
            </Text>
          </Link>
        </li>
        {(isSubscriber || isRoot) && (
          <li>
            <Link href="/management/groups">
              <GroupsIcon />
              <Text as="span" size="medium">
                {t`Groups`}
              </Text>
            </Link>
          </li>
        )}
        <li>
          <Link href="/management/lessons">
            <LessonPlanIcon />
            <Text as="span" size="medium">
              {t`Lessons`}
            </Text>
          </Link>
        </li>
        <li>
          <Link href="/management/assignments">
            <CoverLetterIcon />
            <Text as="span" size="medium">
              {t`Assignments`}
            </Text>
          </Link>
        </li>
        {hasLocalOpportunities && (
          <li>
            <Link
              href={
                versionThreeLocalOpportunities
                  ? '/management/localopportunities'
                  : '/admin/profiles/manage'
              }>
              <NetworkIcon />
              <Text as="span" size="medium">
                {t`Opportunities`}
              </Text>
            </Link>
          </li>
        )}
      </List>
    </Nav>
  )
}

export { Menu }
